import React from 'react'

const CareersSection1 = () => {
  return (
    <section>
      <div className="container">
          <div className="title">
            <h1>
              Silver State Pediatric is committed to providing exceptional care
              for children with complex medical conditions.
            </h1>
          </div>
          <div className="application-information">
            <p>
              Think you would be a great addition to our team? Please fill out an application!
            </p>
            <p>
              We appreciate your interest in the employment opportunities here
              at Silver State Pediatric. Our team includes professionals in
              Nursing (RN, LPN, CNA) Physical, Occupational and Speech Therapy,
              Respiratory Therapy, Social Services, Dietary, Housekeeping,
              Laundry, Maintenance, Business Office, and Activities!
            </p>
            <p>
              Please inquire about current job openings. Pediatric experience is
              recommended but not required. We commit to hire enthusiastic,
              professional and compassionate individuals who enjoy coming to
              work every day.
            </p>
            <p>
              You may use this Application for Employment form below to apply
              for any job.
            </p>
          </div>
      </div>

      <style jsx>{`
        section {
          margin: auto;
          padding-top: 4rem;
          padding-bottom: 6rem;
         
        }
        .container {
          display: flex;
          align-items: center;
          justify-content: space-around;
          z-index: 2;
        }

        h1 {
          font-size: 1.7rem;
          color: #233E94;
          margin: 0;
          line-height: 2.25rem;
          padding: 20px 40px 20px 0;
        }
        h1:before {
          content: "";
          position: absolute;
          height: 5px;
          background: #F69C1F;
          width: 35px;
          bottom: 3.2rem;
          border-radius: 3px;
        }
   
        p {
          
          font-size: 1rem;
          
        }
        @media screen and (max-width: 760px) {
          h1 {
            font-size: 1.7rem;
            color: #233E94;
            margin: 0;
            line-height: 1.9rem;
            padding: 0;
            text-align: center;
          }
          h1:before {
            display: none;
          }
          section {
            padding-top: 5rem;
            padding-bottom: 4rem;
          }

          .container {
            display: block;
          }

          p {
            font-size: 1rem;
            text-align: center;
          }
        }
      `}</style>
    </section>
  )
}

export default CareersSection1
